import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { LazyImage } from '~/components/LazyImage';
import { contentType } from '~/types';

const propTypes = {
  alt: PropTypes.string,
  content: contentType,
  contentPreviewedId: PropTypes.string,
};

const YOUTUBE_PREVIEW_ASPECT_RATIO = 16 / 11;

export const YoutubePreviewCard = ({
  alt = 'YouTube video preview',
  content,
  contentPreviewedId = null,
  ...containerProps
}) => (
  <Box borderRadius="lg" overflow="hidden" {...containerProps}>
    <LazyImage
      ratio={YOUTUBE_PREVIEW_ASPECT_RATIO}
      src={content.thumbnails.high.url}
      imageProps={{ alt, id: contentPreviewedId }}
    />
  </Box>
);

YoutubePreviewCard.propTypes = propTypes;
